var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlineRepeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "outline/repeat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,12 C4.052,12 4.5,12.447 4.5,13 L4.5,13 L4.5,15.471 C4.5,16.314 5.213,17 6.09,17 L6.09,17 L18.086,17 L16.793,15.707 C16.402,15.316 16.402,14.684 16.793,14.293 C17.184,13.902 17.816,13.902 18.207,14.293 L18.207,14.293 L21.207,17.293 C21.598,17.684 21.598,18.316 21.207,18.707 L21.207,18.707 L18.207,21.707 C18.012,21.902 17.756,22 17.5,22 C17.244,22 16.988,21.902 16.793,21.707 C16.402,21.316 16.402,20.684 16.793,20.293 L16.793,20.293 L18.086,19 L6.09,19 C4.11,19 2.5,17.417 2.5,15.471 L2.5,15.471 L2.5,13 C2.5,12.447 2.948,12 3.5,12 Z M5.7932,2.293 C6.1832,1.902 6.8162,1.902 7.2072,2.293 C7.5972,2.684 7.5972,3.316 7.2072,3.707 L7.2072,3.707 L5.9142,5 L17.9102,5 C19.8892,5 21.5002,6.583 21.5002,8.529 L21.5002,8.529 L21.5002,11 C21.5002,11.553 21.0532,12 20.5002,12 C19.9472,12 19.5002,11.553 19.5002,11 L19.5002,11 L19.5002,8.529 C19.5002,7.687 18.7872,7 17.9102,7 L17.9102,7 L5.9142,7 L7.2072,8.293 C7.5972,8.684 7.5972,9.316 7.2072,9.707 C7.0122,9.902 6.7562,10 6.5002,10 C6.2442,10 5.9882,9.902 5.7932,9.707 L5.7932,9.707 L2.7932,6.707 C2.4022,6.316 2.4022,5.684 2.7932,5.293 L2.7932,5.293 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline/repeat",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#0C3058",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineRepeat);
export default __webpack_public_path__ + "static/media/outline_repeat.e6c62e2d36731d28a416639cb4ce5b53.svg";
export { ForwardRef as ReactComponent };